// extracted by mini-css-extract-plugin
export default {"waitingView":"VideoPlayingView_waitingView__CHlvT","logo":"VideoPlayingView_logo__oikj4","player":"VideoPlayingView_player__+CZcu","buttons":"VideoPlayingView_buttons__3Ec01"};